import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scrolled"
export default class extends Controller {
  static values = {
    pixels: Number,
    scroller: String //
  }
  connect() {
    if(this.hasScrollerValue) {
      this.scroller = document.querySelector(this.scrollerValue)
    } else {
      this.scroller = window
    }

    this.scroller.addEventListener("scroll", this.setScrolled.bind(this))
  }

  disconnect(){
    this.scroller.removeEventListener("scroll", this.setScrolled.bind(this))
  }

  setScrolled() {
    if((this.scroller === window ? this.scroller.scrollY : this.scroller.scrollTop) > this.pixelsValue) {
      this.element.classList.add("scrolled")
    } else {
      this.element.classList.remove("scrolled")
    }
  }
}
